<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5802 35L32.0225 25L23.8494 5L19.7628 18.3333L14.0417 11.6667L10.7725 25L20.5802 35ZM20.5802 30L23.8494 28.3333V23.3333L20.5802 25V30Z"
      class="fill-current"
    />
  </svg>
</template>
